import { getAPI } from "../Networking";
import { OpsAnalyticsData } from "../../models/Dashboard/OpsDashboard/OpsAnalytics";
import {
  AnalyticsGraphResponse,
  LabelValue,
} from "../../models/Dashboard/Analytics";
import dayjs from "dayjs";
import { StockCheckAnalyticsAPIFilters } from "../../models/Dashboard/StockCheckDashboard/StockCheckAnalyticsFilters";

export default class StockCheckAnalyticsDashboardAPI {
  getTatsData = async (
    url: string,
    filters: StockCheckAnalyticsAPIFilters
  ): Promise<LabelValue[] | AnalyticsGraphResponse[] | OpsAnalyticsData> => {
    try {
      const start_date = dayjs(filters.start_date, "YYYY-MM-DD")
        .utc()
        .format("YYYY-MM-DD HH:mm:ss");

      const end_date = dayjs(filters.end_date, "YYYY-MM-DD")
        .add(1, "day")
        .utc()
        .format("YYYY-MM-DD HH:mm:ss");

      const queryParams = new URLSearchParams();

      if (start_date) queryParams.append("start_date", start_date);

      if (end_date) queryParams.append("end_date", end_date);

      if (filters.order_id && filters.order_id.length > 0) {
        queryParams.append(
          "order_id",
          filters.order_id.map((item) => item.id).join(",")
        );
      }

      if (filters.raised_by && filters.raised_by.length > 0) {
        queryParams.append(
          "raised_by",
          filters.raised_by.map((item) => item.id).join(",")
        );
      }

      if (filters.closed_by && filters.closed_by.length > 0) {
        queryParams.append(
          "closed_by",
          filters.closed_by.map((item) => item.id).join(",")
        );
      }

      const response = await getAPI(
        `/v5/ops-analytics/stock-check${url}?${queryParams.toString()}`
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };
}
